import { render, staticRenderFns } from "./DashboardExpenses.vue?vue&type=template&id=35d94c43&scoped=true"
import script from "./DashboardExpenses.vue?vue&type=script&lang=js"
export * from "./DashboardExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d94c43",
  null
  
)

export default component.exports